"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[531],{

/***/ 9797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FadeinText; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var hook_useShowAnimation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);




function FadeinText(param) {
    let { duration =1500 , text  } = param;
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const showAnimation = (0,hook_useShowAnimation__WEBPACK_IMPORTED_MODULE_2__/* .useShowAnimation */ .H)(ref);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("transition-opacity ", {
                "opacity-0": !showAnimation
            }, {
                "opacity-100": showAnimation
            }),
            style: {
                transitionDuration: "".concat(duration, "ms")
            },
            children: text
        })
    });
}


/***/ }),

/***/ 26:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _lib_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4327);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);



/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function Image(props, ref) {
    const { alt , loading , src , ...rest } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        ref: ref,
        srcSet: (0,_lib_image__WEBPACK_IMPORTED_MODULE_1__/* .buildSrcSet */ .fY)(src),
        src: (0,_lib_image__WEBPACK_IMPORTED_MODULE_1__/* .buildImageUrl */ .Sc)(src.url),
        ...rest,
        alt: alt || "",
        decoding: "async",
        loading: loading || "lazy"
    });
}));


/***/ }),

/***/ 4531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ TeaserTextSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/icons.tsx
var icons = __webpack_require__(6684);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/container.tsx
var container = __webpack_require__(2606);
// EXTERNAL MODULE: ./lib/types/index.ts
var types = __webpack_require__(608);
// EXTERNAL MODULE: ./components/animation/fadein-text.tsx
var fadein_text = __webpack_require__(9797);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/image.tsx
var components_image = __webpack_require__(26);
// EXTERNAL MODULE: ./hook/useShowAnimation.ts
var useShowAnimation = __webpack_require__(1269);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/animation/scrolling-image.tsx





function ScrollingImage(props) {
    const { className , ...rest } = props;
    const ref = (0,react.useRef)(null);
    const showAnimation = (0,useShowAnimation/* useShowAnimation */.H)(ref);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* default */.Z, {
        ref: ref,
        className: classnames_default()(className, "transition duration-[1500ms]", {
            "scale-105": !showAnimation,
            "scale-100": showAnimation
        }),
        ...rest
    });
}

// EXTERNAL MODULE: ./components/vimeo.tsx + 1 modules
var vimeo = __webpack_require__(9972);
;// CONCATENATED MODULE: ./components/sections/teaser-text.tsx









function TeaserTextSection(param) {
    let { data: { image , vimeoUrl , videoPreset , videoStartAtSecond , title , subTitle , link , layout , paragraph  } , fixedHeight =false  } = param;
    const landscape = !image || image.width > image.height;
    const teaserStyles = classnames_default()("rounded-xl md:rounded-3xl col-span-12 overflow-hidden", {
        "md:order-1": layout === "ImageLeft",
        "md:order-2": layout === "ImageRight",
        "md:col-start-1 lg:col-start-2": landscape && layout === "ImageLeft",
        "md:col-start-2 lg:col-start-3": !landscape && layout === "ImageLeft",
        "md:col-span-6 lg:col-span-5": landscape,
        "md:col-span-5 lg:col-span-4": !landscape,
        "h-96 object-cover": fixedHeight
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
        size: types/* ContainerSize.wide */.B.wide,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid grid-cols-12 gap-1.5 md:gap-6 items-center",
            children: [
                image && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollingImage, {
                    className: teaserStyles,
                    src: image,
                    height: image.height,
                    width: image.width,
                    alt: image.alternativeText,
                    sizes: "(max-width: 768px) 100vw,50vw"
                }),
                vimeoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: teaserStyles,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(vimeo/* default */.Z, {
                        url: vimeoUrl,
                        preset: videoPreset,
                        start: videoStartAtSecond
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("mt-4 md:mt-0 col-start-2 col-span-10 md:col-span-4", {
                        "md:col-start-3 order-1": layout === "ImageRight",
                        "md:order-2": layout === "ImageLeft"
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-iceblue-500 font-bold mb-4 text-17 leading-140 md:text-20 md:leading-124",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fadein_text/* default */.Z, {
                                text: subTitle
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-blue-800 text-22 leading-130 md:text-35 md:leading-130 font-bold",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fadein_text/* default */.Z, {
                                text: title
                            })
                        }),
                        paragraph && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "prose image-text mt-8",
                            dangerouslySetInnerHTML: {
                                __html: paragraph
                            }
                        }),
                        link && /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                            className: classnames_default()("uppercase font-bold text-13 leading-140 tracking-5 text-blue-800 inline-flex items-center mt-8 group"),
                            href: link.url,
                            children: [
                                link.text,
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowIcon */.e0, {
                                    className: "w-12 ml-4 transition-transform duration-500 group-hover:translate-x-2"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 1269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useShowAnimation; }
/* harmony export */ });
/* harmony import */ var _useOnScreen__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4013);

function useShowAnimation(ref) {
    const [, enterCount] = (0,_useOnScreen__WEBPACK_IMPORTED_MODULE_0__/* .useOnScreen */ .R)(ref);
    const showAnimation = enterCount >= 1;
    return showAnimation;
}


/***/ })

}]);